import EdmButton from "atoms/Buttons/EdmButton";
import { ButtonProps } from "react-admin";

export type AddButtonPropsType = { isInPricePositionsInputs?: boolean } & ButtonProps;

export default function AddButton({ isInPricePositionsInputs = false, ...props }: AddButtonPropsType) {
  const { label } = props;

  const sx = isInPricePositionsInputs
    ? {
        position: "absolute",
        top: "-50px",
        left: "95px",
      }
    : {};

  return <EdmButton {...props} sx={sx} label={label || "ra.action.add"} />;
}
